import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { AppSettingsService } from '../app-settings.service';
import { Enums } from '../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss'],
  standalone: false,
})
export class AppSettingsComponent implements OnInit {
  public tabActiveManual = 'ticketsSettings';
  public appSettingsBreadcrumbs = [{ text: 'Настройки системы', url: null }];
  public appSettings = null;
  public appSettingsError: null | string;
  public loading: boolean;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private appSettingsService: AppSettingsService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.appSettingsBreadcrumbs);
    this.getSettings();
  }

  getSettings() {
    this.loading = true;
    this.appSettingsService.getSettings().subscribe(
      (response) => {
        this.appSettings = response['data'];
        this.loading = false;
      },
      (error) => {
        this.appSettingsError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        this.loading = false;
      }
    );
  }

  onChangeSettingsType(changeTabObj) {
    this.tabActiveManual = changeTabObj.currentTab.id;
  }
}
